// extracted by mini-css-extract-plugin
export default {"tech":"HW14_tech__XZpRG","loading":"HW14_loading__Da60g"};